import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useLoyalty, useRedeem } from '../../api/queries.js';

export default function RedeemPoints() {
  const { data, isLoading } = useLoyalty(1);
  const redeem = useRedeem();
  const [confirmKey, setConfirmKey] = useState(null);
  const [successMsg, setSuccessMsg] = useState('');
  const [errorMsg, setErrorMsg] = useState('');

  const points = data?.points ?? 0;
  const rewards = data?.rewards || [];

  const handleRedeem = async (rewardKey) => {
    setErrorMsg('');
    setSuccessMsg('');
    try {
      await redeem.mutateAsync({ rewardKey });
      setSuccessMsg('Récompense échangée avec succès !');
      setConfirmKey(null);
    } catch (err) {
      if (err.status === 400) {
        setErrorMsg('Points insuffisants ou récompense indisponible.');
      } else if (err.status === 429) {
        setErrorMsg('Trop de tentatives, réessayez dans quelques instants.');
      } else {
        setErrorMsg(err.message || 'Une erreur est survenue.');
      }
      setConfirmKey(null);
    }
  };

  return (
    <div className="container" style={{ paddingTop: 'var(--space-6)', paddingBottom: 'var(--space-8)', maxWidth: 600, margin: '0 auto' }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 'var(--space-3)' }}>
        <h1 style={{ fontSize: 'var(--font-size-lg)', fontWeight: 700 }}>
          Echanger mes points
        </h1>
        <Link to="/compte/fidelite" className="btn btn-secondary btn-sm">
          Retour
        </Link>
      </div>

      <div className="card" style={{ padding: 'var(--space-3)', marginBottom: 'var(--space-3)', textAlign: 'center' }}>
        <span style={{ fontSize: 'var(--font-size-sm)', color: 'var(--text-muted)' }}>Solde actuel : </span>
        <span style={{ fontSize: 'var(--font-size-lg)', fontWeight: 700, color: 'var(--waw-yellow)' }}>
          {isLoading ? '...' : points}
        </span>
        <span style={{ fontSize: 'var(--font-size-sm)', color: 'var(--text-muted)' }}> points</span>
      </div>

      {successMsg && (
        <div style={{
          background: 'rgba(0,158,60,0.1)',
          border: '1px solid rgba(0,158,60,0.3)',
          borderRadius: 'var(--radius-client)',
          padding: 'var(--space-2)',
          marginBottom: 'var(--space-3)',
          fontSize: 'var(--font-size-sm)',
          color: 'var(--status-confirmed)',
          textAlign: 'center',
        }}>
          {successMsg}
        </div>
      )}

      {errorMsg && (
        <div style={{
          background: 'rgba(229,0,79,0.1)',
          border: '1px solid rgba(229,0,79,0.3)',
          borderRadius: 'var(--radius-client)',
          padding: 'var(--space-2)',
          marginBottom: 'var(--space-3)',
          fontSize: 'var(--font-size-sm)',
          color: 'var(--waw-pink)',
          textAlign: 'center',
        }}>
          {errorMsg}
        </div>
      )}

      {isLoading && (
        <div style={{ display: 'grid', gap: 'var(--space-2)' }}>
          {Array.from({ length: 3 }).map((_, i) => (
            <div key={i} className="skeleton" style={{ height: 80, borderRadius: 'var(--radius-client)' }} />
          ))}
        </div>
      )}

      {!isLoading && rewards.length === 0 && (
        <div className="card" style={{ padding: 'var(--space-4)', textAlign: 'center' }}>
          <p style={{ color: 'var(--text-muted)' }}>
            Aucune recompense disponible pour le moment.
          </p>
        </div>
      )}

      {rewards.length > 0 && (
        <div style={{ display: 'grid', gap: 'var(--space-2)' }}>
          {rewards.map((reward) => {
            const canAfford = points >= reward.cost;
            const isConfirming = confirmKey === reward.key;

            return (
              <div
                key={reward.key}
                className="card"
                style={{
                  padding: 'var(--space-3)',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  opacity: canAfford ? 1 : 0.5,
                }}
              >
                <div>
                  <div style={{ fontWeight: 600, marginBottom: 4 }}>{reward.label}</div>
                  <div style={{ fontSize: 'var(--font-size-sm)', color: 'var(--waw-yellow)', fontWeight: 700 }}>
                    {reward.cost} points
                  </div>
                  {reward.description && (
                    <div style={{ fontSize: 'var(--font-size-xs)', color: 'var(--text-muted)', marginTop: 4 }}>
                      {reward.description}
                    </div>
                  )}
                </div>

                <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-1)', alignItems: 'flex-end' }}>
                  {isConfirming ? (
                    <>
                      <span style={{ fontSize: 'var(--font-size-xs)', color: 'var(--waw-pink)', fontWeight: 600, textAlign: 'right' }}>
                        Irreversible !
                      </span>
                      <div style={{ display: 'flex', gap: 'var(--space-1)' }}>
                        <button
                          className="btn btn-danger btn-sm"
                          onClick={() => handleRedeem(reward.key)}
                          disabled={redeem.isPending}
                        >
                          {redeem.isPending ? '...' : 'Confirmer'}
                        </button>
                        <button
                          className="btn btn-secondary btn-sm"
                          onClick={() => setConfirmKey(null)}
                        >
                          Annuler
                        </button>
                      </div>
                    </>
                  ) : (
                    <button
                      className="btn btn-primary btn-sm"
                      disabled={!canAfford}
                      onClick={() => setConfirmKey(reward.key)}
                    >
                      Echanger
                    </button>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
